import React, { useState, useEffect } from 'react';
import axios from 'axios';

const IframeDisplay = ({ page }) => {
  const [iframe, setIframe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showIframe, setShowIframe] = useState(false); // New state to control iframe visibility

  useEffect(() => {
    const fetchIframe = async () => {
      setLoading(true); // Ensure loading state is set before the request
  
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/iframes`,
          { page }, // Send 'page' in the request body
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        setIframe(response.data); // Assuming response.data contains the iframe info
      } catch (error) {
        console.error("Error fetching iframe:", error);
        // setError("An error occurred while fetching iframe."); // Uncomment if you need to handle errors
      } finally {
        setLoading(false); // Ensures loading is always turned off
      }
    };
  
    fetchIframe();
  }, [page]); // This effect runs when `page` changes
  

  const handleButtonClick = () => {
    setShowIframe(!showIframe); // Toggle iframe visibility on button click
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
  <div className="flex flex-col items-center justify-center w-full mb-4">
    <button
      onClick={handleButtonClick}
      className="btn btn-info text-white text-xl px-14 mt-4"
    >
      {showIframe ? "Hide Iframe" : "View Iframe"}
    </button>

    {showIframe && iframe && (
      <div className="w-full flex justify-center mt-4">
        <iframe
          src={iframe.url}
          title={iframe.url}
          className="w-full" // Ensures full width but limits max width
          height="1278px"
        />
      </div>
    )}
  </div>
  );
};

export default IframeDisplay;
